import { useState } from 'react';

export default function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);

  return (
    <>
      <footer className="bg-[#0c1527] border-t border-white/[0.06]">
        <div className="w-full px-6 md:px-10 lg:px-16 py-16 md:py-20">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-10 mb-14">
              <div>
                <div className="flex items-center gap-2 mb-5">
                  <svg width="282" height="56" viewBox="0 0 282 56" fill="none" xmlns="http://www.w3.org/2000/svg" className="h-6 lg:h-8 w-auto">
                    <mask id="mask0_5670_126587" maskUnits="userSpaceOnUse" x="0" y="0" width="56" height="56">
                      <path fillRule="evenodd" clipRule="evenodd" d="M0 0H55.3833V55.3833H0V0Z" fill="white"/>
                    </mask>
                    <g mask="url(#mask0_5670_126587)">
                      <path fillRule="evenodd" clipRule="evenodd" d="M27.6071 0.000522485C34.7223 -0.0214219 41.1191 3.40712 46.5482 8.83574C51.9554 14.2424 55.3835 20.6047 55.3835 27.6912V27.607C55.4054 34.7222 51.9774 41.119 46.5482 46.5482C41.1411 51.9554 34.7798 55.3834 27.6928 55.3834H27.7764C20.6617 55.4053 14.2644 51.9768 8.83531 46.5482C3.42917 41.141 9.98045e-05 34.7792 9.98045e-05 27.6927V27.7769C-0.0213221 20.6617 3.40722 14.2644 8.83531 8.83574C14.2425 3.42907 20.6043 0 27.6907 0L27.6071 0.000522485Z" fill="#F96B25"/>
                    </g>
                    <path fillRule="evenodd" clipRule="evenodd" d="M35.4431 15.5455C30.3479 15.4366 28.1355 18.1051 27.5961 20.6984C26.7979 19.209 25.719 17.4276 24.1309 16.5338C23.2724 16.0512 21.6137 15.6447 19.3047 15.4555C17.0171 15.2684 15.6232 14.2422 15.6232 14.2422C15.6232 14.2422 15.6028 17.264 15.5455 19.9422C15.4366 25.0373 18.1046 27.2496 20.6985 27.7886C19.209 28.5877 17.4276 29.6661 16.5339 31.2547C16.0507 32.1121 15.6447 33.7713 15.4555 36.0808C15.2684 38.3679 14.2422 39.7612 14.2422 39.7612C14.2422 39.7612 17.264 39.7821 19.9423 39.8394C25.0375 39.9488 27.2499 37.2803 27.7888 34.687C28.5875 36.1764 29.6658 37.9578 31.2545 38.851C32.1124 39.3337 33.7716 39.7397 36.0812 39.9289C38.3683 40.1165 39.7616 41.1427 39.7616 41.1427C39.7616 41.1427 39.7826 38.1209 39.8399 35.4427C39.9488 30.3476 37.2808 28.1357 34.6869 27.5958C36.1768 26.7977 37.9582 25.7188 38.8515 24.1307C39.3342 23.2722 39.7402 21.6136 39.9293 19.3046C40.117 17.017 41.1427 15.6232 41.1427 15.6232C41.1427 15.6232 38.1214 15.6028 35.4431 15.5455" fill="#293041"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M90.9712 49.7394V31.4964H75.8733V49.7394H66.4609V4.93164H75.8733V22.9189H90.9712V4.93164H100.384V49.7394H90.9712Z" fill="white"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M125.845 50.3805C115.256 50.3805 108.523 44.4271 108.523 32.3933V4.93164H117.936V32.4573C117.936 38.7943 121.009 41.866 125.91 41.866C130.812 41.866 133.884 38.8582 133.884 32.6491V4.93164H143.231V32.2015C143.231 44.4919 136.369 50.3805 125.845 50.3805" fill="white"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M175.835 19.9754C175.835 15.3034 172.893 13.3186 168.449 13.3186H161.39V26.8248H168.645C173.09 26.8248 175.835 24.4573 175.835 20.232V19.9754ZM175.769 49.7394L167.402 35.0166H161.389V49.7394H151.977V4.93164H169.036C179.037 4.93164 185.376 10.0529 185.376 19.7823C185.376 26.6317 181.847 30.9201 176.88 33.0975L186.553 49.7394H175.769Z" fill="white"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M224.89 49.7394V21.1268L214.105 39.6255H213.909L203.189 21.3177V49.7394H194.039V4.93164H203.975L214.04 23.1107L224.171 4.93164H234.172V49.7394H224.89Z" fill="white"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M261.012 17.4744L255.979 32.0693H265.979L261.012 17.4744ZM272.258 49.996L268.86 40.2658H253.172L249.774 49.996H240.297L256.636 4.93164H265.657L281.997 49.996H272.258Z" fill="white"/>
                  </svg>
                </div>
                <p className="text-white/35 text-base leading-relaxed max-w-[220px]">
                  All-in-one HR & Recruitment platform for modern teams.
                </p>
              </div>

              <div className="flex items-center gap-3">
                <a
                  href="https://www.facebook.com/HurmaSystem"
                  target="_blank"
                  rel="nofollow noreferrer"
                  aria-label="Facebook"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/[0.06] hover:bg-brand-orange/20 hover:text-brand-orange text-white/40 transition-all duration-200"
                >
                  <i className="ri-facebook-fill"></i>
                </a>
                <a
                  href="https://t.me/hurmainfo"
                  target="_blank"
                  rel="nofollow noreferrer"
                  aria-label="Telegram"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/[0.06] hover:bg-brand-orange/20 hover:text-brand-orange text-white/40 transition-all duration-200"
                >
                  <i className="ri-telegram-fill"></i>
                </a>
                <a
                  href="https://www.youtube.com/c/HurmaSystem"
                  target="_blank"
                  rel="nofollow noreferrer"
                  aria-label="YouTube"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/[0.06] hover:bg-brand-orange/20 hover:text-brand-orange text-white/40 transition-all duration-200"
                >
                  <i className="ri-youtube-fill"></i>
                </a>
                <a
                  href="https://www.instagram.com/hurma.system/"
                  target="_blank"
                  rel="nofollow noreferrer"
                  aria-label="Instagram"
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-white/[0.06] hover:bg-brand-orange/20 hover:text-brand-orange text-white/40 transition-all duration-200"
                >
                  <i className="ri-instagram-line"></i>
                </a>
              </div>
            </div>

            <div className="border-t border-white/[0.06] pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-white/25 text-xs">© 2026 HURMA. All rights reserved.</p>
              <div className="flex items-center gap-6">
                <button
                  onClick={() => setShowPrivacy(true)}
                  className="text-white/25 text-xs whitespace-nowrap hover:text-white/50 transition-colors duration-200 cursor-pointer"
                >
                  Політика конфіденційності
                </button>
                <div className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-green-400 inline-block"></span>
                  <span className="text-white/25 text-xs">All systems operational</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {showPrivacy && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setShowPrivacy(false)}
          ></div>

          <div className="relative bg-white rounded-xl w-full max-w-[600px] max-h-[85vh] overflow-y-auto shadow-2xl animate-in zoom-in-95 fade-in duration-200">
            <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between rounded-t-xl">
              <h2 className="text-lg font-semibold text-gray-900">Політика конфіденційності</h2>
              <button
                onClick={() => setShowPrivacy(false)}
                className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors duration-200 cursor-pointer"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>

            <div className="px-6 py-6 text-sm text-gray-700 leading-relaxed space-y-4">
              <p>
                Вебсторінка не здійснює безпосереднього збору персональних даних користувачів через форми зворотного зв'язку або іншим чином.
              </p>
              <p>
                Для аналізу відвідуваності та оцінки ефективності роботи цієї вебсторінки можуть використовуватися сервіси веб-аналітики (зокрема, але не виключно, Google Analytics), які обробляють технічну інформацію про використання вебсторінки, серед яких можуть бути дані про перегляди сторінок, тип пристрою, браузер, операційну систему та іншу інформацію, необхідну для формування статистичних звітів і покращення роботи ресурсу.
              </p>
              <p>
                Зазначені технічні дані використовуються агреговано без мети прямої ідентифікації конкретної фізичної особи.
              </p>
              <p>
                Вебсторінка може містити посилання, які переспрямовують Користувача на інші вебсайти. Обробка та збір персональних даних здійснюються відповідно до Політик конфіденційності, розміщених на відповідних вебсайтах.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}